import { render, staticRenderFns } from "./InfoNotice.vue?vue&type=template&id=c92babf0&scoped=true&"
import script from "./InfoNotice.vue?vue&type=script&lang=js&"
export * from "./InfoNotice.vue?vue&type=script&lang=js&"
import style0 from "./InfoNotice.vue?vue&type=style&index=0&id=c92babf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92babf0",
  null
  
)

export default component.exports